import { Camera } from "~/_legacy/types/analysis";
import { CameraResponse } from "~/_legacy/types/api";
import { isNullishOrEmptyObject } from "~/_legacy/utils/compare";
import axiosInstance from "./axios-instance";

const createApiUrl = (branchUid: string) => `branches/${branchUid}/pseudo-camera-orientations/`;

export const fetchCameras = async ({
  branchUid,
  branchVersionId,
}: {
  branchUid: string;
  branchVersionId?: number;
}) => {
  const url = createApiUrl(branchUid);
  const { data } = await axiosInstance.get<CameraResponse[]>(url, {
    params: {
      version: branchVersionId,
    },
  });

  const converted: Camera[] = data.map((camera) => ({
    id: camera.id,
    pseudoCamera: {
      id: camera.pseudo_camera.id,
      branchUid: camera.pseudo_camera.branch_uid,
      defaultCamId: camera.pseudo_camera.default_cam_id,
    },
    originalImageUrl: camera.original_img_url,
    previewImageUrl: camera.preview_img_url,
    analysisNumber: camera.analyzed_id ?? null,
    floorPlanId: camera.floor_plan_id ?? null,
    position: isNullishOrEmptyObject(camera.position)
      ? null
      : {
          x: camera.position.x,
          y: camera.position.y,
          rotation: camera.position.rotation,
        },
    adjustmentConfig: camera.adjustment_status
      ? {
          adjustmentId: camera.adjustment_status.adjustment_id,
          position: {
            x: camera.adjustment_status.position.x,
            y: camera.adjustment_status.position.y,
            rotation: camera.adjustment_status.position.rotation,
          },
          frame: {
            dx: camera.adjustment_status.frame.dx,
            dy: camera.adjustment_status.frame.dy,
          },
        }
      : null,
    additionConfig: camera.extra_camera_orientation_status
      ? {
          additionId: camera.extra_camera_orientation_status.extra_id,
        }
      : null,
  }));

  return converted;
};
